// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"4622d1e6","569":"295ff746"}[chunkId] + ".chunk.js";
};